import React from 'react';

import { Box } from '@mui/material';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';

import DownloadIcon from '../../../../assets/icons/DownloadIcon';
import LinkedInIcon from '../../../../assets/icons/LinkedInIcon';
import ShareIcon from '../../../../assets/icons/ShareIcon';
import { colorsPalette, useIsWidthUp } from '../../../../theme';
import { CustomButton } from '../../../UI/CustomButton';
import useStyles from './styles';

interface ButtonsBlockProps {
  wrapperClass?: string;
  handleClickShare?: () => void;
  onDownloadCertificate: () => void;
  handleClickLinkedIn: () => void;
}

const ButtonsBlock: React.FC<ButtonsBlockProps> = ({
  wrapperClass,
  handleClickShare,
  handleClickLinkedIn,
  onDownloadCertificate,
}) => {
  const isSmall = !useIsWidthUp('lg');
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Box className={cx(classes.buttonsWrapper, wrapperClass)}>
      <CustomButton
        data-testid="openLinkedinModal"
        btnClass={classes.button}
        onClick={handleClickLinkedIn}
      >
        <LinkedInIcon
          color={colorsPalette.white}
          className={cx(classes.buttonIcon, classes.linkedInIcon)}
        />
        {t('page.pathway.addToProfile')}
      </CustomButton>
      <CustomButton btnClass={classes.button} onClick={onDownloadCertificate}>
        <DownloadIcon
          data-testid="downloadCertificate"
          className={classes.buttonIcon}
          color={colorsPalette.white}
        />
        {t('page.pathway.cpdCertificate')}
      </CustomButton>
      <CustomButton
        onClick={handleClickShare}
        btnClass={cx(classes.button, !isSmall && classes.shareButton)}
        data-testid="openShareModal"
      >
        <ShareIcon
          className={cx(classes.shareIcon, isSmall && classes.buttonIcon)}
          color={colorsPalette.white}
        />
        {isSmall && t('page.pathway.share')}
      </CustomButton>
    </Box>
  );
};

export default ButtonsBlock;
